export type SlashCommandMatch = { query: string; start: number; end: number }

/**
 * Matches an active slash-command token at the end of a string.
 *
 * - `(?:^|\s)` — slash must be at the start of text or preceded by whitespace
 * - `(\/[a-zA-Z0-9-]*)` — captures the slash and any following slug characters
 * - `$` — anchored to the end so only the token immediately before the cursor matches
 */
const SLASH_TOKEN = /(?:^|\s)(\/[a-zA-Z0-9-]*)$/

/**
 * Detects an active slash-command at the cursor.
 * Returns `{ query, start, end }` when the cursor sits inside a `/...` token
 * that begins at message start or immediately after whitespace; null otherwise.
 * `query` excludes the leading `/` and is lowercased. `start` is the index of
 * the `/`; `end` is the cursor position so callers can replace start..end.
 */
export default function detectSlashCommand(text: string, caret: number): SlashCommandMatch | null {
  const match = SLASH_TOKEN.exec(text.slice(0, caret))
  if (!match) return null
  const start = match.index + match[0].length - match[1].length
  return { query: match[1].slice(1).toLowerCase(), start, end: caret }
}
